import React from 'react';
import IncentiveProgramDocument from '@/components/membership/documents/IncentiveProgramDocument';

const IncentiveProgram: React.FC = () => {
  return <IncentiveProgramDocument />;
};

export default IncentiveProgram;
